import { Stack, Image, Group } from "@mantine/core"
import { AgecCertificateDetails } from "@tfg/types/endpoints/agec"
import { textColorCssVariable } from "@tfg/types/schemas/communication-studio/cssVariables"

import { DesignStudioParametersToolkit } from "../../utils/designStudioParametersToolkit"

import styles from "./ActivityCertificates.module.css"

type Props = {
  certificates: AgecCertificateDetails[]
  customStyles?: {
    certificatesList?: string
  }
}

export function ActivityCertificates({ certificates, customStyles }: Props) {
  if (certificates.length === 0) return null
  return (
    <Stack className={customStyles?.certificatesList}>
      {certificates.slice(0, 2).map((certificate, i) => (
        <Group
          className={styles.operationCertificate}
          key={i}
          wrap="nowrap"
          gap="xs"
          c={DesignStudioParametersToolkit.getCssVariableLiteralName(
            textColorCssVariable
          )}
        >
          <Image alt="certified" src="/agec/certified.png" w={14} h={18} />
          {certificate.name}
        </Group>
      ))}
    </Stack>
  )
}
